import { render } from "./detection.vue?vue&type=template&id=1a7aa3cc&scoped=true&ts=true"
import script from "./detection.vue?vue&type=script&lang=ts"
export * from "./detection.vue?vue&type=script&lang=ts"

import "./detection.vue?vue&type=style&index=0&id=1a7aa3cc&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a7aa3cc"]])

export default __exports__